import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'real-estate-developments-blueprints',
  storeModule.createStoreModule('real-estate-developments-blueprints')
)
